import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
  background-color: ${({ theme }) => theme.white};
  padding: 20px;
  border-radius: 8px;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const Label = styled.label`
  font-weight: 500;
  color: ${({ theme }) => theme.textColor};
`;

export const Input = styled.input`
  padding: 10px;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.inputBackground};
  color: ${({ theme }) => theme.textColor};
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primaryColor};
    box-shadow: 0 0 0 2px ${({ theme }) => theme.defaultColorShadow};
  }
`;

export const Checkbox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  input {
    width: 18px;
    height: 18px;
    cursor: pointer;
  }
`;

export const Button = styled.button`
  padding: 10px 15px;
  background-color: ${({ theme }) => theme.primaryColor};
  color: #fff;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ theme }) => theme.primaryColorHover};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.lightGray};
    cursor: not-allowed;
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  align-items: center;
`;

export const SearchInput = styled.input`
  flex: 1;
  padding: 10px;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.inputBackground};
  color: ${({ theme }) => theme.textColor};
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primaryColor};
    box-shadow: 0 0 0 2px ${({ theme }) => theme.defaultColorShadow};
  }
`;

export const ErrorMessage = styled.div`
  color: ${({ theme }) => theme.dangerColor};
  background-color: ${({ theme }) => theme.dangerLightColor};
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 15px;
`;

export const SuccessMessage = styled.div`
  color: ${({ theme }) => theme.successColor};
  background-color: ${({ theme }) => (theme.isDark ? '#1e3a2a' : '#d4edda')};
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 15px;
`;

export const ActionButton = styled.button`
  background-color: transparent;
  border: none;
  color: ${({ theme }) => theme.primaryColor};
  cursor: pointer;
  font-size: 14px;

  &:hover {
    text-decoration: underline;
  }
`;

export const SubocorrenciasContainer = styled.div`
  margin-top: 20px;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 4px;
  padding: 15px;
`;

export const SubocorrenciaTitle = styled.h3`
  font-size: 1.2rem;
  margin-bottom: 15px;
  color: ${({ theme }) => theme.textColor};
`;

export const SubocorrenciaItem = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
  align-items: center;
  padding: 10px;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 4px;
`;

export const SubocorrenciaInput = styled.input`
  flex: 1;
  padding: 8px;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.inputBackground};
  color: ${({ theme }) => theme.textColor};
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primaryColor};
    box-shadow: 0 0 0 2px ${({ theme }) => theme.defaultColorShadow};
  }
`;

export const AddButton = styled.button`
  background-color: ${({ theme }) => theme.primaryColor};
  color: #fff;
  border: none;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;

  &:hover {
    background-color: ${({ theme }) => theme.primaryColorHover};
  }
`;

export const HelpText = styled.small`
  color: ${({ theme }) => theme.darkColorLight};
  font-size: 12px;
  margin-top: 4px;
`;

export const IconButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.darkColorLight};
  width: 40px;
  height: 40px;

  &:hover {
    color: ${({ theme }) => theme.darkColor};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const SearchButton = styled(IconButton)`
  background-color: ${({ theme }) => theme.primaryColor};
  color: ${({ theme }) => theme.white};
  border-radius: 4px;

  &:hover {
    background-color: ${({ theme }) => theme.primaryColorHover};
    color: ${({ theme }) => theme.white};
  }
`;

export const SaveButton = styled(IconButton)`
  background-color: ${({ theme }) => theme.primaryColor};
  color: red;
  border-radius: 4px;

  &:hover {
    background-color: ${({ theme }) => theme.primaryColorHover};
    color: ${({ theme }) => theme.white};
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
`;

export const DateContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

export const TableContainer = styled.div`
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px ${({ theme }) => theme.shadowColor};
  overflow: hidden;
`;

export const DateField = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const DateLabel = styled.label`
  font-weight: bold;
  color: ${({ theme }) => theme.textColor};
  white-space: nowrap;
`;

export const FilterInput = styled.input`
  width: 100%;
  padding: 4px 8px;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 4px;
  font-size: 0.85rem;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primaryColor};
    box-shadow: 0 0 0 2px ${({ theme }) => theme.defaultColorShadow};
  }
`;

export const CancelButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: ${({ theme }) => theme.secondaryColor};
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: ${({ theme }) => theme.secondaryColorHover};
  }
`;

export const DeleteTableButton = styled.button`
  background-color: ${({ theme }) => theme.secondaryColor};
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;

  &:hover {
    background-color: ${({ theme }) => theme.secondaryColorHover};
  }

  &:active {
    background-color: ${({ theme }) => theme.secondaryColorHover};
  }
`;

/**
 * Botao de acao principal da barra: icone COM rotulo.
 *
 * O antigo AddButton era um quadrado 40x40 so com o "+", sem texto e sem
 * aria-label -- leitor de tela anunciava apenas "botao", e quem nao conhece a
 * tela tinha de adivinhar.
 */
export const BotaoAcao = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 14px;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  color: ${({ theme }) => theme.white};
  background-color: ${({ theme }) => theme.primaryColor};

  &:hover {
    background-color: ${({ theme }) => theme.primaryColorHover};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.primaryColor};
    outline-offset: 2px;
  }
`;
